import React from "react";
import Backdrop from "../Misc/Backdrop";
import { BsXCircle } from "react-icons/bs";

const FilePreviewModal = ({ fileLocation, fileName, onClose, previewFileForModal }) => {
  const [previewUrl, setPreviewUrl] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    const loadPreview = async () => {
      setLoading(true);
      setError(null);
      try {
        const url = await previewFileForModal(fileLocation);
        setPreviewUrl(url);
      } catch (error) {
        console.error("Error loading preview:", error);
        setError("Failed to load file preview");
      } finally {
        setLoading(false);
      }
    };

    loadPreview();

    return () => {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [fileLocation]);

  const getFileExtension = (filename) => {
    return filename.toLowerCase().split('.').pop();
  };

  const renderPreview = () => {
    if (loading) {
      return (
        <div className="text-center">
          <p className="text-gray-600">Loading preview...</p>
        </div>
      );
    }

    if (error) {
      return (
        <div className="text-center">
          <p className="text-red-500">{error}</p>
        </div>
      );
    }

    const extension = getFileExtension(fileName);
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'heic'];
    const isPdf = extension === 'pdf';
    const isImage = imageExtensions.includes(extension);

    if (isPdf) {
      return (
        <iframe
          src={previewUrl}
          className="w-full h-full border-0"
          title="PDF Preview"
        />
      );
    } else if (isImage) {
      return (
        <img
          src={previewUrl}
          alt={fileName}
          className="max-w-full max-h-full object-contain"
        />
      );
    } else {
      return (
        <div className="text-center">
          <p className="text-gray-600 mb-4">
            Preview not available for this file type
          </p>
          <a
            href={previewUrl}
            download={fileName}
            className="px-4 py-2 bg-blue-reef text-white rounded hover:bg-blue-700"
          >
            Download File
          </a>
        </div>
      );
    }
  };

  return (
    <Backdrop onClick={onClose}>
      <div
        className="w-[90vw] h-[90vh] bg-white rounded shadow flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center p-4 border-b border-gray-200">
          <h2 className="text-base font-bold text-blue-reef">
            File Preview: {fileName}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-600 hover:text-red-500 transition-colors"
          >
            <BsXCircle size={24} />
          </button>
        </div>

        <div className="flex-1 overflow-auto p-4 bg-gray-50 flex items-center justify-center">
          {renderPreview()}
        </div>

        <div className="p-4 border-t border-gray-200 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
          >
            Close
          </button>
        </div>
      </div>
    </Backdrop>
  );
};

export default FilePreviewModal;